import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import useApp from '../context/AppContext'

function Teams({limited, playerCard, basePrice}) {
    
    const {teams} = useApp()
    const Navigate = useNavigate()

    const goToTeam = (id) => Navigate({
        pathname: "/team",
        search: `?team=${id}`
    })

    return (
        <Flex
            direction={'column'}
            gap={3}
            p={4}
            w={playerCard?"60%":'full'}
        >
            <Flex
                justifyContent={'space-between'}
                gap={playerCard?20:10}
                w={'full'}
                px={25}
                // bg="cyan.500"
                // justifyContent={'space-around'}
            >   
                <Text flex={"1"}>Name</Text>
                {!playerCard?
                <>
                <Text>Reserved</Text>
                <Text>Extra</Text>
                <Text>Total</Text>
                </>
                :<Text>Max Auction</Text>}
            </Flex>
            <Flex
                wrap={'wrap'}
                justifyContent={'space-between'}
                gap={2}
            >
            {teams.list.map((key,id) => {
                return (
                    <Flex
                        justifyContent={'space-between'}
                        bg={'rgba(0,0,0,0.2)'}
                        p={2}
                        key={id}
                        borderRadius={10}
                        cursor="pointer"
                        width={playerCard?"45%":'full'}
                        transition={'all 0.25s'}
                        _hover={{
                            border:"1px"
                        }}
                        alignItems={'center'}
                        onClick={() => goToTeam(key)}
                        gap={5}
                    >
                        <Text alignSelf={'flex-start'} fontSize={"md"} fontWeight={'600'} flex={"1"}>{teams?.teams[key]?.name}</Text>
                        {!playerCard?
                        <>
                            <Text>{teams?.teams[key]?.reservedPoints}</Text>
                            <Text>{teams?.teams[key]?.extraPoints}</Text>
                            <Text fontSize='14px' fontWeight={'600'}>{teams?.teams[key]?.points}</Text>
                        </>:
                        <Text alignSelf={'flex-start'}>{
                            teams?.teams[key]?.reservedPoints>=basePrice?
                            basePrice+teams?.teams[key]?.extraPoints: "NA"
                        }</Text>
                        }
                    </Flex>
                )

            })}
            </Flex>

        </Flex>
    )
}

export default Teams